/// <amd-module name="typeahead/core/plugins/ExecutionHelper" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/typeahead/abTest.d.ts" />
/// <reference path="../../../typings/typeahead/browser.d.ts" />
/// <reference path="../../../typings/typeahead/modulizr.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

import * as abTest from "typeahead/core/abTest";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

// prop mapping between StripingConfigration's properties and Context's properties

const supportedProperties = {
    clients : "clientId",
    lobs : "lob",
    locales: "locale",
    siteids : "siteid",
    tabs : "tab",
};

export function evaluateExperiment(experiment: UtaExperiment, deferred: JQueryDeferred<boolean>) {
    if (experiment.name) {
        abTest.getAndLog(experiment.name)
            .done((exp: UtaExperiment) => {
                deferred.resolve(typeof experiment.value !== "undefined" ?
                experiment.value === exp.value : exp.value > 0);
            })
            .fail(() => {
                deferred.resolve(false);
            });
    } else {
        deferred.resolve(false);
    }
}

function getContextProp(configProp: string): string {
    return supportedProperties.hasOwnProperty(configProp) ? supportedProperties[configProp] : null;
}

function getApplicableConfiguration(
                    context: IContext, stripingConfigurations: IStripingConfiguration[]): IStripingConfiguration {

    let stripingConfiguration: IStripingConfiguration;
    for (let i: number = 0; i < stripingConfigurations.length; i++) {
        stripingConfiguration = stripingConfigurations[i];
        let isConfigApplicable: boolean = true;

        for (let configProp in stripingConfiguration) {
            if (configProp !== "experiment" && stripingConfiguration.hasOwnProperty(configProp) &&
                                                                            stripingConfiguration[configProp]) {
                let contextProp: string = getContextProp(configProp);
                if (contextProp && stripingConfiguration[configProp].indexOf(context[contextProp]) < 0) {
                    isConfigApplicable = false;
                    break;
                }
            }
        }
        if (isConfigApplicable) {
            return stripingConfiguration;
        }
    }
    return undefined;
}

export function shouldExecute(context: IContext, stripingConfigurations: IStripingConfiguration[]):
        JQueryPromise<boolean> {
    let deferred: JQueryDeferred<boolean> = $.Deferred();
    if (!stripingConfigurations || !stripingConfigurations.length ||  !context) {
        return deferred.resolve(true).promise();
    }

    let stripingConfig: IStripingConfiguration = getApplicableConfiguration(context, stripingConfigurations);

    if (stripingConfig) {
        if (stripingConfig.experiment) {
            evaluateExperiment(stripingConfig.experiment, deferred);
        } else {
            deferred.resolve(true);
        }

    } else {
        deferred.resolve(false);
    }
    return deferred.promise();
}
